import React from 'react';

export const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse rounded bg-line/70 ${className}`} />
);

/** Squelette de chargement aligné sur la densité du tableau. */
export const TableSkeleton = ({ rows = 6, cols = 5 }) => (
  <div className="divide-y divide-line">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-4 px-4 py-3">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} className={`h-3.5 ${c === 0 ? 'w-40' : 'flex-1'}`} />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
